module.exports = __webpack_public_path__ + "img/joinUs.5b63f92.png";